import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={33}
    fill="none"
    {...props}
  >
    <path
      fill="#EAF5FF"
      d="m58.943 4.092-2.689-2.963c-.743-.818-1.946-.818-2.689 0L33.89 22.805l-5.896-6.496-4 4.405 6.535 10.237c1.856 2.044 4.866 2.044 6.722 0L58.943 7.054c.743-.818.743-2.144 0-2.962Z"
    />
    <path
      fill="#B6D8FF"
      d="M58.271 3.352 35.234 28.729c-.36.396-.837.614-1.343.614h-.002c-.507 0-.985-.219-1.344-.614l-7.173-7.902-2.017 2.221 7.174 7.902c1.856 2.045 4.866 2.045 6.722 0L58.943 7.054c.743-.818.743-2.144 0-2.962l-.672-.74Z"
    />
    <path
      fill="#B6D8FF"
      d="M12.465 30.95 1.057 18.384c-.743-.818-.743-2.144 0-2.962l2.69-2.962c.742-.819 1.946-.819 2.688 0l9.391 10.346L35.501 1.129c.743-.818 1.947-.818 2.69 0l2.688 2.963c.743.818.743 2.144 0 2.962L19.188 30.951c-1.856 2.044-4.866 2.044-6.722 0Z"
    />
    <path
      fill="#54A1F8"
      d="M40.208 3.352 17.17 28.729c-.36.396-.836.614-1.343.614h-.001c-.508 0-.985-.218-1.344-.614L1.729 14.681l-.672.74c-.743.818-.743 2.144 0 2.962l11.408 12.568c1.857 2.044 4.866 2.044 6.722 0L40.88 7.054c.742-.818.742-2.144 0-2.962l-.672-.74Z"
    />
    <path
      stroke="#3B3B3B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m12.477 30.965-11.42-12.58c-.743-.819-.743-2.146 0-2.965l2.692-2.966c.744-.818 1.949-.818 2.692 0l9.4 10.357L35.537 1.114c.743-.819 1.949-.819 2.692 0L40.92 4.08c.743.818.743 2.146 0 2.965l-21.714 23.92c-1.858 2.047-4.87 2.047-6.729 0Z"
    />
    <path
      stroke="#3B3B3B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m30.328 19.02 3.536 3.79L53.56 1.115c.743-.819 1.948-.819 2.692 0l2.692 2.966c.743.818.743 2.146 0 2.965l-21.714 23.92c-1.858 2.047-4.871 2.047-6.73 0l-5.726-6.185"
    />
  </svg>
)
export default SvgComponent
